import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Tenant } from 'src/app/models/tenant/tenant';
import { TenantService } from 'src/app/services/api/tenant.service';
import { MatDialog } from '@angular/material/dialog';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import {translate} from '@jsverse/transloco';
import { UrlService } from 'src/app/services/util/url.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { Constants } from 'src/app/models/constants';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { InstancesService } from 'src/app/services/api/instances.service';
import moment from 'moment';

@Component({
    selector: 'app-create-tenant',
    templateUrl: './create-tenant.component.html',
    styleUrls: ['./create-tenant.component.scss'],
    standalone: false
})
export class CreateTenantComponent   implements OnInit {
  private destroyRef = inject(DestroyRef);

  selectedFilter: any;
  encryptionNonPIIKeyEnable: boolean;
  encryptionPIIKeyEnable: boolean;
  // prodDeploymentClass: any;
  disableProdDeployment: boolean;
  deployment: any;
  @Input() set data(data: any) {
    this.editData = data;
  };
  @Input() edit;
  editData: any;
  Constants = Constants;
  SubscriptionTypes = SubscriptionTypes;
  tenantForm: FormGroup;
  loading = false;
  submitted = false;
  subscriptionDataTest: any;
  subscriptionDataPii: any;
  testSubscribe: any;
  piiSubscribe: any;
  successMessage: any;
  editedSuccess: any;
  isLoading = false;
  encryptionKeyEnable: any;
  toggleEnabledData: any;
  title: any;
  message: any;
  link: any;
  tenantName: any;
  limit = 10;
  invalidEmail = [];
  nonpiiEnabledData: boolean;
  piiEnabledData: boolean;
  // prodEnabledData: boolean;
  minDate: Date;
  contractEndDate: string;
  moment = moment;

  regions: any = ['APAC',' APAC_2','AUSTRALIA','AUSTRALIA_2','BRAZIL','BRAZIL_2','CANADA','EUROPE','FRANCE','GERMANY','INDIA','JAPAN','KOREA','NORWAY','SOUTH_AFRICA','SWEDEN','SWITZERLAND','UK','NORTH_AMERICA','NORTH_AMERICA_2','NORTH_AMERICA_3','NORTH_AMERICA_4','UAE']; 
  scorecards: any = ['SaaS', 'Product', 'BSG'];
  saleschannels: any = ['Accelerate', 'Sandbox', 'SaaSContract'];
  statuses: any = ['Implementation', 'Live', 'Obsolete'];
  cloud: any = ['Azure', 'AWS'];
  filterOptions = [
    {
      label: 'Class A'
    },
    {
      label: 'Class B'
    }
  ];

  subscription = [ {value: ' NON-PII' , selected: true},
    {value: SubscriptionTypes.PII , selected: true},
    {value: ''}
   ];

   addOnBlur = true;
   readonly separatorKeysCodes = [ENTER, COMMA, SPACE] as const;
   emails = []; 

  constructor(private fb: FormBuilder, private tenantService: TenantService, private toastrService: ToastrService,
     private sidenavService: SidenavService, private dialog: MatDialog, private urlService: UrlService, private instancesService: InstancesService) {
    
  }

  ngOnInit(): void {
    this.title = this.edit ? translate('TENANT_LIST.EDIT_TENANT_DETAILS') : translate('TENANT_FORM.NAME');
    this.tenantName = this.edit ? translate('TENANT_FORM.FOUNDATION_REALM_NAME') : translate('TENANT_FORM.FOUNDATION_REALM_NAME');
    // this.selectedFilter = this.editData && this.editData?.parameters?.prodDeploymentClass ? (this.editData?.parameters?.prodDeploymentClass === 'A' ? this.filterOptions[0].label : this.filterOptions[1].label) : this.filterOptions[0].label;
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.minDate.setHours(0, 0, 0, 0);

    if (this.editData?.contractEndDate) {
      this.minDate = this.editData?.contractEndDate;
      const contractDate = new Date(this.editData.contractEndDate);
      this.minDate = new Date(contractDate.setDate(contractDate.getDate() + 1));
    } else {
      this.minDate = this.minDate;
    }

    if(this.editData && this.editData?.parameters?.instanceStopStart?.length > 0) {
      this.editData?.parameters?.instanceStopStart.forEach((value) => {
        if(value === 'nonpii') {
          this.nonpiiEnabledData = true;
        } 
        if(value === 'pii') {
          this.piiEnabledData = true;
        }
        // if(value === 'prod') {
        //   this.prodEnabledData = true;
        // }
      });
    }
    this.toggleEnabledData = true;
    let formConfig: any;
    if(this.toggleEnabledData) {
      formConfig = {
        tenantId: ['', [Validators.required]],
        cloudProvider: ['', [Validators.required]],
        regionPair: ['', [Validators.required]],
        scoreCard: ['', [Validators.required]],
        salesChannel: ['', [Validators.required]],
        status: ['', [Validators.required]],
        ticketNumber: ['', [Validators.required]],
        primaryCloudRegion: [undefined],
        secondaryCloudRegion: [undefined],
        notificationEmails: [undefined],
        customerName: ['', [Validators.required]],
        customerNumber: ['', [Validators.required, Validators.pattern(/^(?!000).*$/)]], 
        customerRegion: [''],
        customerCountry: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]+$/)]], 
        customerMnemonic: [''],
        nonpiiEnabled:this.nonpiiEnabledData,
        piiEnabled:this.piiEnabledData,
        contractEndDate: ['',Validators.required],
        // prodEnabled: this.prodEnabledData,
        // prodDeploymentClass: this.selectedFilter === this.filterOptions[0].label ? 'A' : 'B',
        tenantOwner: ['', [Validators.required]]
      };
    } else {
      formConfig = {
        tenantId: ['', [Validators.required]],
        cloudProvider: ['', [Validators.required]],
        regionPair: [undefined],
        scoreCard: ['', [Validators.required]],
        salesChannel: ['', [Validators.required]],
        status: ['', [Validators.required]],
        ticketNumber: ['', [Validators.required]],
        primaryCloudRegion: ['', [Validators.required]],
        secondaryCloudRegion: ['', [Validators.required]],
        notificationEmails: ['', [Validators.required]],
        customerName: ['', [Validators.required]],
        customerNumber: ['', [Validators.required, Validators.pattern(/^(?!000).*$/)]],
        customerRegion: [''],
        customerCountry: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]+$/)]], 
        customerMnemonic: [''],
        nonpiiEnabled:this.nonpiiEnabledData,
        contractEndDate: [Validators.required],
        piiEnabled:this.piiEnabledData,
        // prodEnabled: this.prodEnabledData,
        // prodDeploymentClass: this.selectedFilter === this.filterOptions[0].label ? 'A' : 'B',
        tenantOwner: ['', [Validators.required]]
      };
    }
    this.tenantForm = this.fb.group(formConfig); 

    if (this.editData) {
      const obj = {
        tenantId: this.editData.tenantId,
      };
        this.instancesService.getInstances(obj)
          .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
          (data: any) => {
            if(data?.total > 0) {
              this.disableProdDeployment = true;
            } else {
              this.disableProdDeployment = false;
            }
          });
      const keys = Object.keys(formConfig);
      const values = this.editData;
      if (this.editData?.notificationEmails) {
        this.emails = this.editData.notificationEmails;
      }
      keys.forEach(key => {
        if (values[key] && key !== 'notificationEmails') {
          this.tenantForm.get(key).setValue(values[key]);
        }
      });
    }
  }

  // filterOptionChange(option): void {
  //   this.selectedFilter = option;
  //   if (option) {
  //     this.prodDeploymentClass = option === this.filterOptions[0].label ? 'A' : 'B';
  //     this.tenantForm.get('prodDeploymentClass').setValue(this.prodDeploymentClass);
  //   } 
  // }

  nonpiiEnabled(event): void {
    this.nonpiiEnabledData = event.checked;
    if(this.nonpiiEnabledData === true) {
      this.encryptionNonPIIKeyEnable = true;
    } else {
      this.encryptionNonPIIKeyEnable = false;
    }
  }

  // prodEnabled(event): void {
  //   this.prodEnabledData = event.checked;
  // }


  piiEnabled(event): void {
    this.piiEnabledData = event.checked;
    if(this.piiEnabledData === true) {
      this.encryptionPIIKeyEnable = true;
    } else {
      this.encryptionPIIKeyEnable = false;
    }
  }


  onSubmit(): void {
    if(this.tenantForm.get('contractEndDate').value !== ''){
      this.tenantForm.get('contractEndDate').setErrors(null);
    }
    if(!FormUtilService.validateForm(this.tenantForm)) {
      return;
    }
    if(!this.toggleEnabledData) {
      if(this.tenantForm.get('primaryCloudRegion').value?.toLowerCase() === this.tenantForm.get('secondaryCloudRegion').value?.toLowerCase()) {
          this.setErrorToNameControl();
        } else {
          const data = this.tenantForm.value;
          this.createTenant();
        }
    } else {
      const data = this.tenantForm.value;
      this.createTenant();
    }
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
       if (this.emails.length <= this.limit) {
        const emails = this.emails.map(item => item.toLowerCase());
        const findDuplicate = emails.find(item => item === value.toLowerCase());
        if (!findDuplicate) {
          this.emails.push(value);
        }
      }
    }
    event.chipInput!.clear();
  }

  isValidEmail(email): boolean {
    const validateEmail = /^[a-zA-Z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,4}$/;
    const splitEmail = email.split('@');
    if (validateEmail.test(email) && splitEmail[1].toLowerCase() === 'temenos.com') {
      return true;
    } else {
      const emails = this.invalidEmail?.map(item => item.toLowerCase());
      const findDuplicate = emails.find(item => item === email.toLowerCase());
      if (!findDuplicate) {
        this.invalidEmail.push(email);
      }
    }
  }

  remove(email): void {
    const index = this.emails.indexOf(email);
    if (index >= 0) {
      this.emails.splice(index, 1);
    }

    if(this.invalidEmail.includes(email)) {
      const emailIndex = this.invalidEmail.indexOf(email);
      this.invalidEmail.splice(emailIndex, 1);
    }
  }

  private setErrorToNameControl(): void {
    setTimeout(() => this.tenantForm.get('secondaryCloudRegion').setErrors({regionValidation: true}));
  }

  onValChange(value): void {
    if(value === 'temenos') {
      this.toggleEnabledData = true;
    } else {
      this.toggleEnabledData = false;
    }
    if(this.toggleEnabledData) {
      this.tenantForm.get('primaryCloudRegion').reset();
      this.tenantForm.get('secondaryCloudRegion').reset();
      this.tenantForm.controls.primaryCloudRegion.setErrors(null);
      this.tenantForm.controls.secondaryCloudRegion.setErrors(null);
    } else {
      this.tenantForm.get('regionPair').reset();
      this.tenantForm.controls.regionPair.setErrors(null);
    }
   }

   openUrl(): void {
    this.urlService.openUrlInNewTab('https://dashboard.bankingcloud.temenos.com/userguide/docs/operator/tenant-onboarding#supported-regions');
  }

  cancel(): void {
    this.sidenavService.closeRightSidenav();
    this.tenantForm.reset();
  }

  closeSidenav(): void {
     this.sidenavService.closeRightSidenav();
  }

  /**
   * On clicking Submit button, A new Tenant will get created.
   */
  private createTenant(): void {
    const tenantFormIsValid = FormUtilService.validateForm(this.tenantForm);
    if (tenantFormIsValid) {
      if (!this.edit) {
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('TENANT_FORM.TITLE'),
            message:translate('TENANT_FORM.MESSAGE'),
            confirmButtonText: translate('BUTTONS.CONFIRM')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
            this.isLoading = true;
            const tenant = this.tenantForm.getRawValue();
            tenant.contractEndDate = moment(tenant.contractEndDate).utcOffset("+05:30").format("YYYY-MM-DD"); 
            let instanceStopStartData = [];
            if(tenant.nonpiiEnabled) {
              instanceStopStartData.push('nonpii');
            }
            if(tenant.piiEnabled) {
              instanceStopStartData.push('pii');
            }
            // if(tenant.prodEnabled) {
            //   instanceStopStartData.push('prod');
            // }
            tenant.parameters = {
              instanceStopStart: instanceStopStartData
              // prodDeploymentClass: tenant.prodDeploymentClass
            }
            // delete tenant.prodDeploymentClass;
            delete tenant.nonpiiEnabled;
            delete tenant.piiEnabled;
            // delete tenant.prodEnabled;
            tenant.notificationEmails = this.emails;
            this.tenantService.createTenant(tenant)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: (res) => {
                this.successMessage = true;
                this.isLoading = false;
              },
              error: (error) => {
                this.isLoading = false;
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '630px',
                  panelClass: 'flex-dialog',
                  data: {
                    title:  translate('ERROR_DIALOG.ADD_TENANT_FAILED'),
                    description: errorMessage
                  }
                });

              }
            });
          }
        });
      } else {
          this.editTenant();
        }
      }

  }

  private editTenant() {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('TENANT_LIST.EDIT_TENANT_DETAILS'),
        message:translate('TENANT_FORM.UPDATE_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
        this.isLoading = true;
        const tenant = this.tenantForm.getRawValue();
        tenant.contractEndDate = moment(tenant.contractEndDate).utcOffset("+05:30").format("YYYY-MM-DD");
        let instanceStopStartData = [];
            if(tenant.nonpiiEnabled) {
              instanceStopStartData.push('nonpii');
            }
            if(tenant.piiEnabled) {
              instanceStopStartData.push('pii');
            }
            tenant.parameters = {
              instanceStopStart: instanceStopStartData
              // prodDeploymentClass: tenant.prodDeploymentClass
            }
            // delete tenant.prodDeploymentClass;
            delete tenant.nonpiiEnabled;
            delete tenant.piiEnabled;
        tenant.notificationEmails = this.emails;
        this.tenantService.updateTenant(tenant)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (res) => {
            this.editedSuccess = true;
            this.isLoading = false;
          },
          error: (err) => {
            this.isLoading = false;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('ERROR_DIALOG.EDIT_TENANT_FAILED'),
                description: err?.errmsg? err.errmsg: err?.error
              }
            });
          }
        });
      }
    });
  }

  get formControls(): any {
    return this.tenantForm.controls;
  }

}
